<template>
    <div>
        <h1>Бизнес-площадки</h1>
				<div class="columns is-multiline competitions_columns list_elements_3_col">
            <div v-for="(competition, index) in paginatedCompetitions" :key="competition.id"
                 class="column competition__wrapper is-4-desktop" :class="index % 2 === 0 ? 'col2' : 'col1'">
								<div class="competition_wrapper_inside">
                    <div class="competition_wrapper_inner" style="position: relative">
                        <div class="competition_do">
                            <div class="competition_do_inner">
                                <div class="competition_do_circle"></div>
                                До {{ formatDate(competition.endDate) }}
                            </div>
                        </div>
                        <div class="competition_wrapper_inner" style="position: relative">
                            <div class="competition-image-wrapper">
                                <a class="competition-title"
                                   :href="'/competition/single/'+competition.id">
                                    <ImageRender
																						class-name="competition_image"
                                            :src="get_uploaded_image_asset(competition.avatar)" >
																		</ImageRender>
<!--																		<img class="competition_image" :src="get_uploaded_image_asset(competition.avatar)">-->
																</a>
                            </div>
                        </div>
                        <div class="competition-info">
                            <p class="competition-type">{{ competition.napravlenie }}</p>
<!--                            <p class="competition-title__wrapper">{{-->
<!--																truncateText(competition.name, 50)-->
<!--                                }}</p>-->
                        </div>
										</div>
								</div>
            </div>
        </div>
        <Pagination
                :current="current"
                :pageSize="pageSize"
                :total="competitions.length"
                @change="(page)=>{current = page;}"
        ></Pagination>

    </div>
</template>

<script setup>
import {ref, computed} from "vue";
import axios from "axios";
import {Pagination} from "ant-design-vue";
import moment from "moment";
import ImageService from "@/services/ImageService";
import ImageRender from "@/components/Base/ImageRender.vue";

moment.locale('ru');

let competitions = ref([]);
let current = ref(1);
let pageSize = ref(12);

const paginatedCompetitions = computed(() => {
  const start = (current.value - 1) * pageSize.value;
  const end = start + pageSize.value;
  return competitions.value.slice(start, end);
})


async function getCompetitions() {
  const response = await axios.get('/competition/get_bussines_competitions');
  competitions.value = response.data;
}

getCompetitions();

function formatDate(date) {
  return moment(date).format('D MMMM YYYY');
}

function truncateText(text, maxLength) {
  if (text !== null && text.length > maxLength) {
    return text.slice(0, maxLength) + '...';
  } else {
    return text;
  }
}

function get_uploaded_image_asset(path) {
  return ImageService.getCompetitionImagePath(path);
  // let base_path = 'https://script.moviestart.ru';
	//
  // if (path === null || path.length === 0) {
  //   path = base_path + '/images/iconfinder_gallery_2199104.png';
  // } else {
  //   path = base_path + '/uploads/images/' + path;
  // }
  // return path;
}

</script>

<style scoped>
.competition-image {
    width: 100%;
}

.competition-info {
    padding: 20px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}

.button2 {
    background: transparent;
}

/*.competition_wrapper {*/
/*    position: relative;*/
/*    padding: 30px;*/
/*    background: #FFF;*/
/*    border-radius: 30px;*/
/*    margin-top: 40px;*/
/*    margin-bottom: 30px;*/
/*    max-width: 424px;*/
/*    display: flex;*/
/*    flex-direction: column;*/
/*    width: 100%;*/
/*    align-items: baseline;*/
/*}*/

.competition-image-wrapper:deep img {
    border-radius: 20px;
}

.competition-title {
    color: #000000;
    font-size: 18px;
    font-weight: 600;
    line-height: normal;
}

.competition_do {
    padding: 15px 25px;
    background: rgba(235, 122, 25, 0.07);
    color: #1E2329;
    border-radius: 50px;
    font-weight: 400;
    font-size: 20px;
    margin-bottom: 30px;
    display: inline-block;
}

.competition_do_inner {
    display: flex;
    align-items: center;
    font-family: Play, sans-serif;
}

.competition_do_circle {
    background: #EE9D46;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 18px;
}

.content .competition-type {
    text-transform: uppercase;
    margin-bottom: 7px !important;
}

.competition-title__wrapper {
    flex-grow: 1;
}

.competiton_order_button_div {
    margin-top: 35px;
    font-family: Play, sans-serif;
}

.competiton_order_button {
    color: #EE9D46;
    font-weight: 400;
}

.competiton_order_button i {
    margin-left: 10px;
}

.competition_image {
    width: 100%;
    margin-bottom: -1px;
}

/*.info_block .column {*/
/*    padding-left: 0;*/
/*}*/
.content p:not(:last-child) {
    margin-bottom: auto;
}

.info_block p {
    margin-bottom: 10px;
}

.describe_text {
    color: #1E2329;
    font-weight: 400;
    font-size: 24px;
    font-family: 'Play';
}

.number_circle {
    background: #EDECEC;
    width: 67px;
    height: 67px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #8F9194;
    font-weight: 400;
    font-size: 30px;
}

.number_circle_text {
    color: #1E2329;
    margin-top: 40px;
    font-size: 24px;
    font-family: Play, sans-serif;
    line-height: normal;
}

.number_circle_active {
    background: #EE9D46;
    color: #fff;
}

.number_circles_block {
    margin-top: 80px;
}

.number_circles_block .column {
    position: relative;
}

.line {
    border-top: 5px solid #EDECEC;
    width: 84%;
    position: absolute;
    left: 79px;
    top: 43px;
}

.footer {
    background: #fff;
}

.filter_button__wrapper {
    position: relative;
}

.filter_button_title {
    font-weight: 400;
    font-size: 20px;
    color: #1E2329;
    margin-bottom: 25px;
    font-family: 'Play';
}

.filter_button_window {
    background: #FFFDFD;
    box-shadow: 0px 7px 41px -8px rgba(30, 35, 41, 0.3);
    border-radius: 17px;
    padding: 30px 20px;
    max-width: 345px;
    position: absolute;
    top: 49px;
    z-index: 11;
    left: 0;
    display: none;
}

.button5 {
    padding: 15px;
}

.button5__wrapper {
    margin-top: 35px;
}

.button5__wrapper .button5 {
    width: 100%;
}

button.button5 {
    border: 0;
}


@media (max-width: 1450px) {
    .number_circle {
        width: 55px;
        height: 55px;
    }

    .number_circle_text {
        font-size: 20px;
    }

    .number_circles_block {
        margin-top: 55px;
    }

    .line {
        left: 69px;
        top: 38px;
    }

    .number_circle_text {
        margin-top: 25px;
    }

    body > header {
        padding-bottom: 50px;
    }

    .competition_wrapper {
        max-width: 360px;
    }

    .competition_do {
        font-size: 17px;
    }

    .competition_wrapper {
        padding: 20px;
    }

    .competition_do_circle {
        width: 10px;
        height: 10px;
        margin-right: 14px;
    }

    .competition-title {
        font-size: 17px;
    }
}


@media (max-width: 1220px) {
    .competition_wrapper {
        max-width: 295px;
    }
}

@media (min-width: 1024px) {
    .column.is-5-desktop {
        width: 48%;
    }
}

@media (max-width: 1000px) {
    .line {
        display: none;
    }

    .section {
        padding: 0 15px;
    }

    .number_circle_text {
        font-size: 20px;
    }

    .describe_text {
        font-size: 20px;
    }

    .number_circles_block {
        margin-top: 30px;
    }

    .number_circle {
        width: 45px;
        height: 45px;
        font-size: 25px;
    }

    .competition_wrapper {
        padding: 10px;
        max-width: 48%;
        flex-basis: auto;
        min-width: 168px;
        border-radius: 15px;
        margin-top: 0;
    }

    .competitions_columns {
        margin-top: 30px;
    }

    .competition_do_inner {
        font-size: 11px;
    }

    .competition_do_circle {
        margin-right: 5px;
        margin-bottom: 0;
        width: 7px;
        height: 7px;
    }

    .competition-image-wrapper:deep img {
        border-radius: 12px;
    }

    .competition-info {
        padding: 0;
    }

    .competition-type {
        font-size: 12px;
        margin-top: 30px;
    }

    .competition-title__wrapper {
        line-height: 1;
    }

    .competition-title {
        font-size: 13px;
    }

    .competiton_order_button {
        font-size: 13px;
    }

    .competiton_order_button_div {
        margin-top: 10px;
    }

    .competition_do {
        padding: 8px 10px;
        margin-bottom: 15px;
    }

    /*.pagination-list {*/
    /*    flex-grow: 1;*/
    /*    width: 100%;*/
    /*}*/
}

@media (max-width: 370px) {
    .competition_wrapper {
        max-width: 100%;
    }
}
</style>